import {reporter} from 'common/report/error-reporting';
import {DATASET_MIXPANEL} from 'common/report/constants';

import {BaseClient} from '../utils/base-client';
import {processProperties} from './utils';

class PeoplePropertiesClient extends BaseClient {
  buildEndpoint() {
    return `api/2.0/engage/properties`;
  }

  buildQueryParams(options = {}) {
    const {
      projectId,
      datasetId,
      profileTable,
      dataGroupId,
      includeCustom,
      includeDimensionProperties,
      workspaceId,
      useQueryCache,
    } = {
      projectId: null,
      datasetId: DATASET_MIXPANEL,
      profileTable: null,
      dataGroupId: null,
      includeCustom: false,
      includeDimensionProperties: null,
      workspaceId: null,
      useQueryCache: null,
      ...options,
    };
    /* eslint-disable camelcase */
    return {
      project_id: projectId,
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      // TODO(RNA-183): Remove once profileTypes are removed from Insights.
      ...(profileTable && !dataGroupId ? {where: `properties["Table"] == "${profileTable}"`} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(includeCustom ? {include_custom: includeCustom} : {}),
      ...(includeDimensionProperties ? {include_dimension_props: includeDimensionProperties} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      ...(useQueryCache !== null ? {use_query_cache: useQueryCache} : {}),
    };
    /* eslint-enable camelcase */
  }

  processResponse(response, params) {
    if (response.status === `ok`) {
      try {
        // Getting empty keys was having downstream impacts and will be filtered out here
        // see https://mixpanel.slack.com/archives/C07KZ4NBB/p1605105643087200
        const sanitizedResults = Object.fromEntries(
          Object.entries(response.results).filter(([key, value]) => !!key && !!value),
        );
        return processProperties(sanitizedResults, {dataGroupId: params.dataGroupId});
      } catch (err) {
        reporter.error(err);
      }
    } else {
      if (!response.error.includes(`Your account is blocked because payment is required`)) {
        reporter.error(`Unsuccessful PeoplePropertiesClient response ${response.error}`, response);
      }
    }
    return [];
  }
}

export const peoplePropertiesClient = new PeoplePropertiesClient();
